<!-- 教育局-机构管理 -->
<template>
  <div>
    <div class="index" v-if="!detail.show && !addShow && !employeesShow">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <!-- <div class="Homeboxtop_nav_tab">
			<span
				v-for="(item, index) in tabList"
				:class="['res-tab', { active: item.name === tabName }]"
				:key="index"
				@click="tabClick(item)"
			>
				{{ item.name }}
			</span>
		</div> -->
      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-input
              placeholder="请输入机构名称"
              v-model="queryParams.org_name"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item v-show="tabName === '审核通过'" label="">
            <el-select
              v-model="queryParams.org_record_status"
              clearable
              placeholder="教育部备案状态"
              class="label"
            >
              <el-option
                v-for="item in recordStatusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="tabName === '审核通过'" label="">
            <el-select
              v-model="queryParams.status"
              clearable
              placeholder="账号状态"
              class="label"
            >
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px; float: right">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <el-button
              v-show="tabName === '审核通过'"
              type="primary"
              size="small"
              @click="add()"
              >新建</el-button
            >
            <el-button
              v-show="tabName === '待审核'"
              type="primary"
              size="small"
              @click="searchFun()"
              >批量核验</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 待审核 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
            <el-table-column
              prop="org_name"
              show-overflow-tooltip
              label="机构"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="identity" label="服务类型" align="center">
            </el-table-column> -->
            <el-table-column
              prop="create_user_name"
              show-overflow-tooltip
              label="联系人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="org_social_credit_code"
              show-overflow-tooltip
              label="执照代码"
              width="140px"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="org_source_name"
              show-overflow-tooltip
              label="来源"
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="tabName === '审核通过'"
              prop="org_record_status"
              label="教育部备案状态"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.org_record_status === '1' ? 'green' : 'red',
                  }"
                >
                  {{ scope.row.org_record_status | recordStatusFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tabName === '审核通过'"
              prop="time"
              label="账号状态"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.status | statusFilter }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              fixed="right"
              width="120px"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看</el-button
                >
                <!-- <el-button
                  v-show="tabName === '审核通过'"
                  type="text"
                  size="small"
                  @click="reject(scope.row.org_id)"
                  style="margin-left: 10px"
                  >从业人员</el-button
                > -->
                <el-button
                  v-show="tabName === '审核不通过'"
                  type="text"
                  size="small"
                  @click="pass(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="page.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pageSize"
              :total="page.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Employees
      :orgId="selectOrgId"
      v-show="employeesShow"
      @to-index="toIndex"
    ></Employees>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
    <!-- <Information :info="detail.info" v-show="detail.show" @to-index="toIndex"></Information> -->
    <Add :info="detail.info" v-show="addShow" @to-index="toIndex"></Add>
  </div>
</template>
<script>
import {
  getOrgList,
  createOrg,
  getQYInfo,
  getOrgQYList,
} from "@/api/user/userCenter";
export default {
  components: {
    Employees: () => import("./employees.vue"),
    Detail: () => import("./detail.vue"),
    //  Information: () => import("./information.vue"),
    Add: () => import("./add.vue"),
  },
  data() {
    return {
      statusColor: "",
      queryParams: {
        org_name: "",
        status: "",
        org_record_status: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      addShow: false,
      employeesShow: false,
      detail: {
        info: {},
        show: false,
      },
      statusList: [
        { id: "0", label: "未激活" },
        { id: "1", label: "正常" },
      ],
      recordStatusList: [
        { id: "0", label: "未备案" },
        { id: "1", label: "已备案" },
      ],
      tableData: [],
      tabList: [
        { name: "审核通过" },
        { name: "审核不通过" },
        { name: "待审核" },
      ],
      tabName: "审核通过",
      visible: false,
      selectOrgId: "",
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
    this.getAllOrgIds();
  },
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    recordStatusFilter(type) {
      const typeMap = {
        0: "未备案",
        1: "已备案",
      };
      return typeMap[type] || "未备案";
    },
  },
  methods: {
    async getDataList() {
      let isPlatform =
        JSON.parse(window.sessionStorage.getItem("userInfo"))
          .v_platform_code ===
          JSON.parse(window.sessionStorage.getItem("userInfo")).platform_code  ||
        JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).v_platform_code.includes(",");
      // console.log("调用机构列表2");
      let params = {
        // org_id:sessionStorage.getItem("orgId")||'', //	机构、学校等组织id
        org_name: this.queryParams.org_name, //	机构、学校等组织名称
        org_type: "8", //8	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
        province_code: "", //	所属地理省份
        city_code: "", //	所属地理市
        area_code: "", //	所属地理区
        status: this.queryParams.status, //       	状态,多个使用英文逗号分隔(0:组织未激活,1:正常)
        // platform_code:"",
        // v_platform_code:"",
        platform_code: isPlatform ? sessionStorage.getItem("platformCode") : "", //	实体平台编码
        v_platform_code: isPlatform
          ? ""
          : JSON.parse(window.sessionStorage.getItem("userInfo"))
              .v_platform_code, //	虚拟平台编码
        certification: "", //	认证(0:未认证,1:已认证)2
        org_category: "", //	组织的类别(见文档十三.4，每个类型的组织都有自己的类别)
        org_level_code: "", //	行政区划(行政上所属的区域)
        org_parent_id: "", //	上级机构id(查的是直属下级单位)
        org_parent_ids: sessionStorage.getItem("orgid_top") || "", //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
        flag: "", //	         标记,多个使用英文逗号分隔,默认正常和演示(0:正常,1:演示,2:测试)
        page: this.page.pageNum, //	查询页单独的对的
        page_size: this.page.pageSize, //	查询条数，默认10，上限10011
        is_more: "1", //	返回更多信息(0:否,1:是)
        org_record_status: this.queryParams.org_record_status, // 教育局备案状态
        more_field: [
          "user_name",
          "org_record_status",
          "school_legal_person_name",
          "school_legal_person_code",
          "org_code_certificate",
          "org_address",
          "org_telephone",
          "org_social_credit_code",
          "status",
          "org_source_level",
          "org_resource_id",
          "org_record_status", //教育局备案状态,0:未备案，1：已备案
        ], //	指定返回的字段名称,传入看示例
        sort: "time", //按时间排序
      };
      var { code, result } = await getOrgList(params);
      if (code === "000000") {
        this.tableData = result.lists;
        this.page.totalPage = result.count;
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
      console.log("机构-列表", this.tableData);
    },
    async getAllOrgIds() {
      if (!sessionStorage.getItem("orgIdGrop")) {
        let isPlatform =
          JSON.parse(window.sessionStorage.getItem("userInfo"))
            .v_platform_code ===
            JSON.parse(window.sessionStorage.getItem("userInfo"))
              .platform_code
        let params = {
          // org_id:sessionStorage.getItem("orgId")||'', //	机构、学校等组织id
          org_name: this.queryParams.org_name, //	机构、学校等组织名称
          org_type: "8", //8	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
          province_code: "", //	所属地理省份
          city_code: "", //	所属地理市
          area_code: "", //	所属地理区
          status: this.queryParams.status, //       	状态,多个使用英文逗号分隔(0:组织未激活,1:正常)
          // platform_code:"",
          // v_platform_code:"",
          platform_code: isPlatform
            ? sessionStorage.getItem("platformCode")
            : "", //	实体平台编码
          v_platform_code: isPlatform
            ? ""
            : JSON.parse(window.sessionStorage.getItem("userInfo"))
                .v_platform_code, //	虚拟平台编码
          certification: "", //	认证(0:未认证,1:已认证)2
          org_category: "", //	组织的类别(见文档十三.4，每个类型的组织都有自己的类别)
          org_level_code: "", //	行政区划(行政上所属的区域)
          org_parent_id: "", //	上级机构id(查的是直属下级单位)
          org_parent_ids: sessionStorage.getItem("orgid_top") || "", //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
          flag: "", //	         标记,多个使用英文逗号分隔,默认正常和演示(0:正常,1:演示,2:测试)
          page: this.page.pageNum, //	查询页单独的对的
          page_size: 99999, //	查询条数，默认10，上限10011
          is_more: "1", //	返回更多信息(0:否,1:是)
          org_record_status: this.queryParams.org_record_status, // 教育局备案状态
          more_field: [
            "org_record_status",
            "school_legal_person_name",
            "school_legal_person_code",
            "org_code_certificate",
            "org_address",
            "org_telephone",
            "org_social_credit_code",
            "status",
            "org_source_level",
            "org_resource_id",
          ], //	指定返回的字段名称,传入看示例
          sort: "time", //按时间排序
        };
        var { code, result } = await getOrgList(params);
        if (code === "000000") {
          sessionStorage.orgIdGrop = result.lists
            .map((it) => it.org_id)
            .join(",");
          //  console.log('获取全部getAllOrgIds',sessionStorage.getItem('orgIdGrop'));
        }
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    add() {
      this.addShow = true;
    },
    sizeChangeHandle(val) {
      // let that;
      // if(this.tabName==='待审核'){
      // 	that=this.queryParams;
      // }else if(this.tabName==='审核通过'){
      // 	that=this.queryParams_2;
      // }else{
      // 	that=this.queryParams_3;
      // }

      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      console.log("点击查看机构详情----", item);
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
      this.addShow = false;
      this.employeesShow = false;
      // this.page.pageNum = 1;
      this.getDataList();
    },
    pass(id) {},
    reject(id) {
      this.selectOrgId = id;
      this.employeesShow = true;
    },
    //  locking (id) {
    // 	let params = {
    //     usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
    //     user_id:userId,
    //     status:'3',//0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
    //   };
    // //   var { code, message } = await setUserStatus(params);
    //   if (code == "000000") {
    //      this.page.pageNum=1
    //      this.getDataList()
    //      this.$message({
    //       type: "success",
    //       message: "操作成功",
    //     });
    //   }else{
    //     this.$message({
    //       type: "error",
    //       message: message,
    //     });
    //   }
    //  },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    width: 100%;
    padding: 0 15px 15px;
    text-align: center;
  }
}
</style>
